import { formatBps } from "@/lib/format";

type Props = {
  readonly bps: number;
  readonly onChange: (bps: number) => void;
};

const PRESETS = [5_000, 6_000, 7_000, 8_000, 9_000, 9_500] as const;

export const StepFactorInput = ({ bps, onChange }: Props) => (
  <section>
    <div className="flex items-baseline justify-between mb-3">
      <h3>Step factor</h3>
      <span
        className="font-mono tabular text-[12px]"
        style={{ color: "var(--ink-2)" }}
      >
        {formatBps(bps)}
      </span>
    </div>
    <p
      className="font-mono text-[10px] leading-relaxed mb-3"
      style={{ color: "var(--ink-4)" }}
    >
      Fraction of pledged collateral borrowed each iteration. Higher = fewer
      rounds, higher leverage ceiling. Lower = smoother convergence.
    </p>
    <div className="flex gap-2">
      {PRESETS.map((p) => {
        const active = bps === p;
        return (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className="flex-1 h-9 rounded-[2px] text-[11px] tracking-[0.12em] uppercase transition-all border"
            style={{
              background: active ? "var(--surface-2)" : "transparent",
              color: active ? "var(--ink-1)" : "var(--ink-2)",
              borderColor: active ? "var(--ink-1)" : "var(--line-2)",
              fontWeight: 500,
            }}
          >
            {formatBps(p)}
          </button>
        );
      })}
    </div>
  </section>
);
